module.exports = "https://p.cds.unp.clasificados.pe/logo-gec-grey.62246916b2af6d61f615377b8eb35f35.svg";